import { render, staticRenderFns } from "./UploadProductImage.vue?vue&type=template&id=54c77f39&scoped=true&"
import script from "./UploadProductImage.vue?vue&type=script&lang=ts&"
export * from "./UploadProductImage.vue?vue&type=script&lang=ts&"
import style0 from "./UploadProductImage.vue?vue&type=style&index=0&id=54c77f39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c77f39",
  null
  
)

export default component.exports